// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-6xEPJyMExv1yRUji0tXue." + "a4101384ca854227" + ".js";
};